<template>
	<div>
		<div class="w-full flex flex-col items-center">
			<ToolBar>
				<div class="w-full flex items-center justify-between">
					<div class="w-5/12 flex items-center">
						<SearchGroup
							:search="patientSearch"
							custom-classes="text-uppercase"
							@change="patientSearch = $event || ''"
						/>
					</div>

					<button
						class="btn btn-tool"
						:disabled="!patientSearch"
						@click="showPatientModal = true"
					>
						<i class="fas fa-plus font-20"></i>
					</button>
				</div>
			</ToolBar>

			<MainContent>
				<div class="w-full px-4 py-5 flex justify-center">
					<div class="w-5/12 flex align-items-center">
						<transition-group
							mode="out-in"
							name="fade"
							tag="div"
							class="w-full flex flex-col gap-5"
						>
							<div
								v-for="patient in filteredPatients"
								:key="patient.id"
								:class="[
									'select-card',
									{
										'desconhecido-card':
											patient.desconhecido,
									},
								]"
							>
								<label @click="Select(patient)">
									<div
										class="d-flex align-items-center patient-card"
									>
										<div class="ml--2 mr-4">
											<div class="float-left box box-1">
												<img
													:src="
														GetAvatar(
															patient.avatar
														)
													"
													class="img-cover rounded-lg"
												/>
											</div>
										</div>
										<div
											class="flex-grow-1 p-0 d-flex flex-column justify-content-center card-body"
										>
											<span
												v-if="patient.desconhecido"
												class="col-auto badge-desconhecido"
											>
												DESCONHECIDO
											</span>
											<div class="fw-bold mb-1">
												{{
													patient.nome_social &&
													patient.nome_social !=
														'null'
														? patient.nome_social
														: patient.nome_paciente
												}}
											</div>
											<div class="d-flex card-documents">
												<div
													class="col-4 px-0 d-flex flex-column"
												>
													<small
														class="opacity-60 d-block"
													>
														{{
															patient.rg
																? 'RG: ' +
																  patient.rg
																: patient.cpf
																? 'CPF: ' +
																  patient.cpf
																: patient.sus
																? 'CNS: ' +
																  patient.sus
																: 'ID: DESCONHECIDO'
														}}
													</small>
													<small
														class="opacity-60 d-block"
													>
														<template>
															SEXO:
															{{
																patient.sexo ===
																'm'
																	? 'MASCULINO'
																	: patient.sexo ===
																	  'f'
																	? 'FEMININO'
																	: 'DESCONHECIDO'
															}}
														</template>
													</small>
												</div>
												<div
													class="col px-0 d-flex flex-column"
												>
													<small
														class="opacity-60 d-block rh"
													>
														<template
															v-if="patient.rh"
														>
															{{ patient.tipo }}:
															{{ patient.numero }}
														</template>
													</small>
													<small
														class="opacity-60 d-block"
													>
														DATA DE NASCIMENTO:
														{{
															patient.data_nascimento
																? formatDate(
																		patient.data_nascimento
																  )
																: 'DESCONHECIDO'
														}}
													</small>
												</div>
											</div>
										</div>
									</div>
									<i class="far fa-chevron-right"></i>
								</label>
							</div>
						</transition-group>
					</div>
				</div>
			</MainContent>
		</div>

		<PatientModal
			v-if="showPatientModal"
			form-type="pre"
			@close="showPatientModal = false"
			@new="New"
		/>
	</div>
</template>

<script>
	import Helpers from '../../../helpers'
	const helpers = new Helpers()

	const _ = require('lodash')

	import { mapGetters, mapActions } from 'vuex'
	import Swal from 'sweetalert2'
	import moment from 'moment'

	export default {
		name: 'Patient',
		props: {
			label: {
				type: String,
				default: '',
			},
			patientId: {
				type: [Number, String, null],
				default: null,
			},
			autoNav: {
				type: Boolean,
				default: true,
			},
			patient: {
				type: Object,
				default: null,
			},
			search: {
				type: String,
				default: '',
			},
		},
		data() {
			return {
				patients: [],
				selected: {
					patient: null,
				},
				form_type: 'standard',
				base_name: null,
				patientSearch: '',
				showPatientModal: false,
			}
		},
		computed: {
			...mapGetters('auth', ['requester_selected_id']),
			filteredPatients() {
				const patients = this.patients.filter(patient => {
					let allowed = false
					let search = helpers
						.RemoveAcento(this.patientSearch)
						.toLowerCase()

					if (patient.nome_social) {
						allowed = helpers
							.RemoveAcento(patient.nome_social)
							.toLowerCase()
							.includes(search)
					}

					if (!allowed && patient.nome_paciente) {
						allowed = helpers
							.RemoveAcento(patient.nome_paciente)
							.toLowerCase()
							.includes(search)
					}

					if (!allowed && patient.rh) {
						allowed = helpers
							.SanitizedDocument(helpers.RemoveAcento(patient.rh))
							.toLowerCase()
							.includes(helpers.SanitizedDocument(search))
					}

					if (!allowed && patient.cpf) {
						allowed = helpers
							.SanitizedDocument(patient.cpf)
							.includes(helpers.SanitizedDocument(search))
					}

					if (!allowed && patient.sus) {
						allowed = helpers
							.RemoveAcento(patient.sus)
							.toLowerCase()
							.includes(search)
					}

					if (!allowed && patient.rg) {
						let rgWithUf = `${patient.rg}${
							patient.rg_uf ? ' ' + patient.rg_uf : ''
						}`
						let rgWithUfNoSpace = `${patient.rg}${
							patient.rg_uf ? patient.rg_uf : ''
						}`

						let searchWithoutSpaces = search
							.replace(/\s/g, '')
							.toLowerCase()

						allowed =
							helpers
								.RemoveAcento(rgWithUf)
								.toLowerCase()
								.includes(searchWithoutSpaces) ||
							helpers
								.RemoveAcento(rgWithUfNoSpace)
								.toLowerCase()
								.includes(searchWithoutSpaces)
					}

					if (!allowed && patient.telefone) {
						let telefone

						try {
							telefone = JSON.parse(
								patient.telefone.replace(/\\/g, '')
							)
						} catch (err) {
							telefone = []
						}

						if (Array.isArray(telefone) && telefone.length > 0) {
							telefone.forEach(tel => {
								if (
									tel &&
									!allowed &&
									tel.replace(/\D/g, '').indexOf(search) > -1
								) {
									allowed = true

									return
								}
							})
						}
					}

					return allowed
				})

				return this.patientSearch
					? patients.length >= 10
						? patients.slice(0, 10)
						: patients
					: []
			},
		},
		watch: {
			patient: {
				handler(val) {
					if (val && !_.isEmpty(val)) {
						this.selected.patient = val
						this.patientSearch = val.nome_paciente
					}
				},
				immediate: true,
			},
			filteredPatients: {
				handler(val) {
					this.$emit('patients-list', val)
				},
				immediate: true,
			},
		},
		methods: {
			...mapActions('system', ['StartLoading', 'FinishLoading']),
			async GetPatientsForScheduling() {
				this.StartLoading()

				return window.api
					.call('post', '/get-patients-for-scheduling', {
						account_id: this.requester_selected_id,
					})
					.then(({ data }) => {
						if (data.response) {
							this.patients = _.sortBy(data.patients, [
								'nome_paciente',
							])
						} else {
							Swal.fire({
								icon: 'error',
								title: 'Opss...',
								text: 'Houve um erro ao obter os pacientes, contate o suporte.',
							})
						}
					})
					.finally(() => {
						this.FinishLoading()
					})
			},
			GetAvatar(path) {
				return path ? path : '/img/profile.png'
			},
			NewPatientModal() {
				window.jQuery('#patient-modal').modal('show')

				this.form_type = 'standard'

				this.selected.patient = null

				this.$refs.patientForm.ClearForm()
			},
			New(patient) {
				this.patients.push(patient)

				window.jQuery('#patient-modal').modal('hide')

				window.jQuery('body').removeClass('modal-open')

				this.Select(patient)
			},
			Select(patient, autoWalkStep = true) {
				this.selected.patient = patient
				this.$emit('change:autoNav', true)

				// const patient_phones = patient.telefone
				// 	? JSON.parse(patient.telefone)
				// 	: []
				// const hasPhoneNumber =
				// 	patient_phones?.length && patient_phones[0] != null
				// if (!hasPhoneNumber) {
				// 	this.selected.patient.telefone_1 = null

				// 	Swal.fire({
				// 		icon: 'warning',
				// 		title: 'PREENCHA O TELEFONE DO PACIENTE.',
				// 		toast: true,
				// 		position: 'top',
				// 		customClass: {
				// 			container: 'themed',
				// 		},
				// 	})

				// 	this.form_type = 'update'

				// 	window.jQuery('#patient-modal').modal('show')
				// }

				if (!this.autoNav) return
				this.$emit('next', {
					patient: this.selected.patient,
					autoWalkStep,
				})
			},
			Previous() {
				this.$emit('previous')
			},
			formatDate(date) {
				if (date) return moment(date).format('DD/MM/YYYY')
			},
		},
		async beforeMount() {
			await this.GetPatientsForScheduling()

			if (this.patientId) {
				const patient = this.patients.find(
					p => p.id === Number(this.patientId)
				)

				if (patient) {
					this.Select(patient, false)
				}
			}
		},
	}
</script>

<style lang="css" scoped>
	.patient-card > .card-body {
		height: 93px;
	}

	.rh {
		height: 21px;
	}

	.card-documents {
		gap: 15px;
	}

	.select-card.desconhecido-card:hover label {
		background-color: var(--warning-hover) !important;
		border-color: var(--warning-hover) !important;
		color: #fff !important;
	}

	.select-card.desconhecido-card:hover i {
		background-color: var(--light) !important;
		color: var(--warning-hover) !important;
		opacity: 0.6;
	}

	.badge-desconhecido {
		background-color: #f3b43c;
		color: #000;
		font-weight: bold;
		border-radius: 4px;
		padding-inline: 4px;
		font-size: 0.85rem;
		width: fit-content;
	}

	.select-card.desconhecido-card:hover .badge-desconhecido {
		background-color: var(--warning);
		color: #fff;
	}
</style>
